import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "task",
  "use": "task-usage",
  "viewBox": "0 0 23.4 24",
  "content": "<symbol viewBox=\"0 0 23.4 24\" id=\"task\"><path d=\"M9.8 13.6l2.8 3.2c-.2.5-.3 1.1-.3 1.7 0 3 2.5 5.5 5.5 5.5.7 0 1.4-.1 2-.4l-4.2-4.2 3.1-3.1 4.2 4.2c.3-.6.4-1.3.4-2 0-3-2.4-5.5-5.5-5.5-.8 0-1.6.2-2.3.5l-2.6-3-1.6-1.6-.9-1.1c.4-.7.6-1.5.6-2.3C11 2.5 8.5 0 5.5 0c-.7 0-1.4.1-2 .4l4.2 4.2-3.1 3.1L.4 3.5c-.3.6-.4 1.3-.4 2 0 3 2.5 5.5 5.5 5.5.6 0 1.2-.1 1.7-.3L8.3 12l1.5 1.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/task.svg
// module id = tKhF
// module chunks = 1